<template>
  <!-- レポート作成 -->
  <div id="AnalysisReport">
    <div id="container">
      <div class="labelTitle lable">解析業務 業務報告書</div>
      <!--検索条件 -->
      <div class="condition-area">
        <template v-if="isAnalyst">
          <table class="conditionTable" style="width:600px;">
            <tr>
              <th>解析期限</th><td style="width:400px;"><input type="date" v-model="serchCondition.analysisDeadlineStart" /> ～ <input type="date" v-model="serchCondition.analysisDeadlineEnd"/></td>
            </tr>
          </table>
        </template>
        <template v-else>
          <table class="conditionTable">
            <tr>
              <th>解析期限</th><td style="width:400px;"><input type="date" v-model="serchCondition.analysisDeadlineStart" /> ～ <input type="date" v-model="serchCondition.analysisDeadlineEnd"/></td>
              <th>解析担当者</th>
              <td style="width:400px;">
                <input type="text" style="width:270px;" disabled="disabled" v-model="serchCondition.analysisStaffName"/>
                <b-button style="margin-left:10px; width:150px; height:27px;" @click="analyistSelectModalActive=true">担当者選択</b-button>
             </td>
            </tr>
          </table>
        </template>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>

      </div>
      <!-- 検索結果 -->
      <div v-if="data.result.length > 0">
        <div id="item-contens">
            <div class="card-content margin-top">
                <table>
                    <tr><th>期間</th><td>{{data.analysisDeadlineStart}} ～ {{data.analysisDeadlineEnd}}</td></tr>
                    <tr><th>担当者</th><td>{{data.analysisStaffName}}</td></tr>
                </table>
            </div>
        </div>
        <div class="button-area">
          <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy('analysisReportTable')">クリップボードにコピー</b-button>
        </div>
        <div class="table-wrapper">
            <table id="analysisReportTable">
                <thead>
                    <tr><th></th><th>解析期限</th><th>医療機関</th><th>患者名</th></tr>
                </thead>
                <tbody>
                    <template v-for="(item, index) in data.result">
                        <tr :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{item.analysisDeadline}} </td>
                            <td>{{item.medicalInstitutionName}}</td>
                            <td>{{item.patientName}}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="button-area">
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>

    </div>
    <b-modal :active.sync="analyistSelectModalActive" has-modal-card>
      <analyistSelectModal :selectRole="[role.role_psc, role.role_analysis]" title="解析担当者選択" labelForOrg="解析担当者" @select="setAnalyist"></analyistSelectModal>
    </b-modal>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
import AnalyistSelectModal from "@/components/mock/philips/common/AnalyistSelectModal";
export default {
  name: "AnalysisReport",
  methods: {
    doSearch: function() {
      if (!this.inputCheck()) {
        return;
      }

      var excuteApi = this.getSpreadsheetBusinessReportPOST;
      var successCallBack = this.getSpreadsheetBusinessReportPOSTSuccess;
      var errorCallBack = this.getSpreadsheetBusinessReportPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getSpreadsheetBusinessReportPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.serchCondition));
      return client.apis.internalSpreadsheet.getSpreadsheetBusinessReportPOST({
        body:obj
      });
    },
    getSpreadsheetBusinessReportPOSTSuccess: function(result) {
      // 検索結果取得
      this.data.result = result.obj
      this.data.analysisDeadlineStart = this.replaceSlash(this.serchCondition.analysisDeadlineStart);
      this.data.analysisDeadlineEnd = this.replaceSlash(this.serchCondition.analysisDeadlineEnd);
      this.data.analysisStaffName = this.serchCondition.analysisStaffName;
    },
    getSpreadsheetBusinessReportPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    inputCheck: function() {
      if (!this.serchCondition.analysisDeadlineStart || !this.serchCondition.analysisDeadlineEnd) {
        this.showErrorMessage('解析期限を入力してください。');
        return false
      }

      if (this.serchCondition.analysisDeadlineStart > this.serchCondition.analysisDeadlineEnd) {
        this.showErrorMessage('解析期限の開始/終了の関係に誤りがあります。');
        return false
      }

      if (!this.serchCondition.analysisStaffId) {
        this.showErrorMessage('解析担当者を選択してください。');
        return false
      }

      return true
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      var tbody = btable.getElementsByTagName("tbody")[0];
      navigator.clipboard.writeText(tbody.innerText).then(() => {
          this.showMessage("クリップボードにコピーしました。");
        }).catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
    setAnalyist: function(analyistInfo) {
      this.serchCondition.analysisStaffId = analyistInfo.id;
      this.serchCondition.analysisStaffName = analyistInfo.orgName;
    },
    back: function() {
      this.$router.go(-1);
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var isAnalyst = userInfo.roleId == role.role_analysis;

    var analysisStaffId = null
    var analysisStaffName = ""
    if (isAnalyst) {
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      analysisStaffId = userInfo.id;
      analysisStaffName = userInfo.lastName + ' ' + userInfo.firstName
    }

    return {
        role: role,
        isAnalyst: isAnalyst,
        data: {
          analysisDeadlineStart:"",
          analysisDeadlineEnd:"",
          analysisStaffName:"",
          result:[]
        },
        analyistSelectModalActive: false,
        hasResult: false,
        serchCondition: {
          analysisStaffId: analysisStaffId,
          analysisStaffName: analysisStaffName
        }
    };
  },
  filters: {},
  components: {
    analyistSelectModal:AnalyistSelectModal,    
  }
};
</script>
<style lang="scss" scoped>
input {
  width: 200px;
}
.table-wrapper {
    max-height: 1100px;
    overflow-y: scroll;
}
#analysisReportTable {
    font-size: 100% !important;
}
#analysisReportTable tr,
#analysisReportTable th,
#analysisReportTable td{
    border: black 1px solid;
    text-align: center;
}
#analysisReportTable td{
    width: 60px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/spreadSheet/AnalysisReport.vue